import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';

@Directive({
    selector: '[minValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MinValidatorDirective, multi: true }],
    standalone: true,
})
export class MinValidatorDirective implements Validator {
	@Input() minValidator: number;

	validate(control: AbstractControl): { [key: string]: any } {
		return Validators.min(this.minValidator)(control);
	}
}
